import React, { Component } from "react";
import { Link } from "react-router-dom";

// Images
import bannerImg from "../../images/banner/banner1.jpg";
import weChatImg from "../../images/about/wechat_brisbane.jpg";
import youTubeImg from "../../images/about/youtube.png";
import facebookImg from "../../images/about/facebook.png";
import linkedInImg from "../../images/about/linkedin.png";

// Layout
import Header1 from "../layout/header/header1";

import { withTranslation } from "react-i18next";

class BecomeOurStudents extends Component {
	constructor(props) {
		super(props);
		this.state = {
			name: "",
			email: "",
			contact_number: "",
			gender: "",
			age: "",
			school: "",
			content: "",
		};
		this.itemRefs = [];
	}
	componentDidMount() {

	}

	handleChange = (event) => {
		const { name, value } = event.target;
		this.setState({ [name]: value });
	};

	render() {
		const { t } = this.props;
		const { i18n } = this.props;
		const currentLang = i18n.language;
		const imagePath = currentLang === 'zh'
			? require('../../images/courses/course_poster_brisbane_zh_term3.png')
			: require('../../images/courses/course_poster_brisbane_en_term3.png');

		return (
			<>
				<Header1 />

				<div className="page-content">
					<div
						className="page-banner ovbl-dark"
						style={{ backgroundImage: "url(" + bannerImg + ")" }}
					>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">{t("Header_Become_Our_Students_Queensland")}</h1>
							</div>
						</div>
					</div>
					<div className="breadcrumb-row">
						<div className="container">
							<ul className="list-inline">
								<li>
									<Link to="/">{t("Become_Our_Students_LinkHome")}</Link>
								</li>
								<li>{t("Become_Our_Students_Link_Queensland")}</li>
							</ul>
						</div>
					</div>
					<div className="content-block">
						<div className="page-banner contact-page">
							<div className="container-fluid container">
								<div className="row m-lr0">
									<div className="col-lg-12 col-md-12 section-sp2 p-lr30">
										<div className="heading-bx left p-r15">
											<h2 className="title-head">{t("Contact_Registration")}</h2>
										</div>
										<div className="content-block">
											<div className="section-area section-sp1">
												<div className="container">
													<div className="row d-flex flex-row-reverse">
														<div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
															<h1 className="text-start">{t("Schedule_Content_H")}</h1>
															<div className="courses-post">
																<img alt="" src={imagePath} />
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className={`card-header-step`}>
											<h5 className="mb-0">
												Step 1: Select the Correct Course
											</h5>
										</div>
										<div className="card-body">
											Read <a
												href="/courses-details"
												target="_blank"
												style={{ textDecoration: 'underline', color: 'rgb(51, 126, 187)' }}
												rel="noreferrer"
											>
												<b>2026 Term 3 Course Schedule and Course Details </b></a> to find out the course introduction for your child
										</div>
										<div className={`card-header-step`}>
											<h5 className="mb-0">
												Step 2: Confirm with Leading Coding about Course Price
											</h5>
										</div>
										<div className={`card-header-step`}>
											<h5 className="mb-0">
												Step 3: Terms and Conditions
											</h5>
										</div>
										<div className="card-body">
										<p></p>
											More details please read <a
												href="/static/pdf/Leading_Coding_Admission_Policy.pdf"
												target="_blank"
												style={{ textDecoration: 'underline', color: 'rgb(51, 126, 187)' }}
												rel="noreferrer"
											><b>Leading Coding Admission Policy</b></a> and <a
												href="/static/pdf/Leading_Coding_Privacy_Policy.pdf"
												target="_blank"
												style={{ textDecoration: 'underline', color: 'rgb(51, 126, 187)' }}
												rel="noreferrer"
											><b>Leading Coding Privacy Policy</b></a>
										</div>
										<div className={`card-header-step`}>
											<h5 className="mb-0">
												Step 4: Submit Required Forms
											</h5>
										</div>
										<div className="card-body">
											New Students fill <a
												href="https://docs.google.com/forms/d/e/1FAIpQLSc5yLMVA-zcH2EXz2YQzDvL33b6ufqGJ_iXgu3LvjlhYc_VmA/viewform?usp=header"
												target="_blank"
												style={{ textDecoration: 'underline', color: 'rgb(51, 126, 187)' }}
												rel="noreferrer"
											><b>2026 Term 3 Leading Coding Headquarter - Brisbane Program Registration Form (New Students)</b></a>
											<br />
											Current Students fill <a
												href="https://docs.google.com/forms/d/e/1FAIpQLSen0UnoZiLU9sXoekKlCHQS_pbhY5m5PsNilLUGzCv4TprU-Q/viewform?usp=header"
												target="_blank"
												style={{ textDecoration: 'underline', color: 'rgb(51, 126, 187)' }}
												rel="noreferrer"
											>
												<b>2026 Term 3 Leading Coding Headquarter - Brisbane Program Registration Form (Current Students)</b>
											</a>
										</div>
										<div className="card-body">
											<h5>Online Payment</h5>
											Name: Leading Coding<br />
											BSB: 105 086<br />
											Account: 060 872 640<br />
											<b>Please write your child's name (the same as that in registration form) in the reference</b><br />
											<p></p>
											<h5>In-Person (Cash)</h5>
											Visit <a
												href="https://www.google.com/maps/place/l1%2F218+Padstow+Rd,+Eight+Mile+Plains+QLD+4113/"
												target="_blank"
												style={{ textDecoration: 'underline', color: 'rgb(51, 126, 187)' }}
												rel="noreferrer"
											><b>L1/ 218 Padstow Rd, Eight Mile Plains QLD 4113</b></a> during class hours on Sundays
										</div> 
									</div>
								</div>
							
								<div className="row m-lr0">
									<div className="col-lg-12 col-md-12 section-sp2 p-lr30">
										<div className="heading-bx left p-r15">
											<h2 className="title-head">{t("Contact_Information_QLD")}</h2>
										</div>
										<div className="row placeani">
											<div className="col-lg-4 pull-right">
												<div className="label">
													<h3>{t("Contact_Phone_Label_QLD")}</h3>
												</div>
											</div>
											<div className="col-lg-8 pull-right">
												<div className="value">
													<div style={{ fontSize: 28 + "px" }}>
														{t("Contact_Phone_Value_QLD")}
													</div>
												</div>
											</div>
										</div>
										<div className="row placeani">
											<div className="col-lg-4 pull-right">
												<div className="label">
													<h3>{t("Contact_Email_Label_QLD")}</h3>
												</div>
											</div>
											<div className="col-lg-8 pull-right">
												<div className="value">
													<div style={{ fontSize: 28 + "px" }}>
														{t("Contact_Email_Value_QLD")}
													</div>
												</div>
											</div>
										</div>

										<div className="row placeani">
											<div className="col-lg-4 pull-right" style={{ marginTop: 30 }}>
												<div className="label">
													<h3>{t("Contact_Wechat_Label_QLD")}</h3>
												</div>
											</div>
											<div className="col-lg-8 pull-right">
												<div className="value">
													<img alt=""
														style={{ width: 100 + "px", height: 100 + "px" }}
														src={weChatImg}
													/>
												</div>
											</div>
										</div>

										<div className="row placeani">
											<div className="col-lg-4" style={{ marginTop: 30 }}>
												<div className="label">
													<h3>{t("Contact_Youtube_Label_QLD")}</h3>
												</div>
											</div>
											<div className="col-lg-8 d-flex">
												<div className="d-flex align-items-center justify-content-center" style={{ width: 100, height: 100 }}>
													<a
														rel="noreferrer"
														href="https://www.youtube.com/@LeadingCoding"
														target="_blank"
													>
														<img
															alt=""
															src={youTubeImg}
															style={{ maxWidth: "100%", maxHeight: "100%" }}
														/>
													</a>
												</div>
											</div>
										</div>

										<div className="row placeani">
											<div className="col-lg-4" style={{ marginTop: 30 }}>
												<div className="label">
													<h3>{t("Contact_Facebook_Label_QLD")}</h3>
												</div>
											</div>
											<div className="col-lg-8 d-flex">
												<div className="d-flex align-items-center justify-content-center" style={{ width: 90, height: 90, paddingLeft: 10 }}>
													<a
														rel="noreferrer"
														href="https://www.facebook.com/profile.php?id=61550979300196"
														target="_blank"
													>
														<img
															alt=""
															src={facebookImg}
															style={{ maxWidth: "100%", maxHeight: "100%" }}
														/>
													</a>
												</div>
											</div>
										</div>

										<div className="row placeani">
											<div className="col-lg-4" style={{ marginTop: 30 }}>
												<div className="label">
													<h3>{t("Contact_Linkedin_Label_QLD")}</h3>
												</div>
											</div>
											<div className="col-lg-8 d-flex">
												<div className="d-flex align-items-center justify-content-center" style={{ width: 100, height: 100 }}>
													<a
														rel="noreferrer"
														href="https://www.linkedin.com/company/leading-coding"
														target="_blank"
													>
														<img
															alt=""
															src={linkedInImg}
															style={{ maxWidth: "100%", maxHeight: "100%" }}
														/>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default withTranslation()(BecomeOurStudents);
